// These argument types are official parts of the TS spec, so we can't avoid using any here.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function replacer(this: any, key: string, value: any): any {
    const originalObject = this[key];

    if (originalObject instanceof Map) {
        return {
            dataType: 'Map',
            value: Array.from(originalObject.entries()),
        };
    }

    return value;
}

// These argument types are official parts of the TS spec, so we can't avoid using any here.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reviver(key: string, value: any): any {
    if (typeof value === 'object' && value !== null) {
        if (value.dataType === 'Map') {
            return new Map(value.value);
        }
    }

    return value;
}

export function setInLocalStorage<T>(
    key: string,
    updater: (prevValue: T | null) => T | null,
): { error?: Error; success?: boolean } {
    const prevValue = localStorage.getItem(key);
    let parsedPrevValue = null;

    if (prevValue !== null) {
        try {
            // JSON.parse() will throw if there is a circular reference
            parsedPrevValue = JSON.parse(prevValue, reviver);
        } catch (err) {
            return { error: err as Error };
        }
    }

    const updatedValue = updater(parsedPrevValue);

    try {
        // localStorage.setItem() may throw if storage is full
        localStorage.setItem(key, JSON.stringify(updatedValue, replacer));
    } catch (err) {
        return { error: err as Error };
    }

    return { success: true };
}

export function getInLocalStorage<T>(key: string): T | null {
    const rawItem = localStorage.getItem(key);

    if (rawItem === null) {
        return rawItem;
    }

    try {
        // JSON.parse() will throw if there is a circular reference
        const parsedItem = JSON.parse(rawItem, reviver);

        return parsedItem;
    } catch (err) {
        return null;
    }
}
